(function(){
'use strict';
if(window.PGRewardReconcileV102Installed)return;
window.PGRewardReconcileV102Installed=true;

var timer=0;
function isCartMutation(url){
  return /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:[?#]|$)/i.test(String(url||''));
}
function wakeRewards(){
  clearTimeout(timer);
  timer=setTimeout(function(){
    timer=0;
    var engine=window.PGRewardEngineV101;
    if(engine&&typeof engine.refresh==='function'){
      Promise.resolve(engine.refresh()).catch(function(){});
    }else if(typeof window.pgCartSync==='function'){
      Promise.resolve(window.pgCartSync()).catch(function(){});
    }
  },120);
}

var previousFetch=window.fetch;
if(typeof previousFetch==='function'){
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&input.url)||'';
    var response=previousFetch.apply(this,arguments);
    if(isCartMutation(url)){
      Promise.resolve(response).then(function(res){
        if(res&&res.ok)wakeRewards();
      }).catch(function(){});
    }
    return response;
  };
}

if(window.XMLHttpRequest&&window.XMLHttpRequest.prototype){
  var previousOpen=window.XMLHttpRequest.prototype.open;
  var previousSend=window.XMLHttpRequest.prototype.send;
  window.XMLHttpRequest.prototype.open=function(method,url){
    this._pgRewardV102Url=url;
    return previousOpen.apply(this,arguments);
  };
  window.XMLHttpRequest.prototype.send=function(){
    var xhr=this;
    this.addEventListener('load',function(){
      if(xhr.status>=200&&xhr.status<300&&isCartMutation(xhr._pgRewardV102Url))wakeRewards();
    },{once:true});
    return previousSend.apply(this,arguments);
  };
}
})();
